import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useRef} from "react";
import classNames from "classnames";
import { SlidingHeaderMenu } from "ui-components-rollup/dist/SlidingMenu";
import styles from "../MainHeader.module.scss";
import {TransitionChevron} from "ui-components-rollup/dist/Widgets";
import buttonStyles from "ui-components-rollup/src/components/buttons.module.scss";

export const CaptionButton = ({title, value, isActive, className, onClick, buttonRef}) => {
    return <button ref={buttonRef} onClick={onClick} title={value} className={className}>
        <div className={styles['caption-button-title']}>{title}</div>
        <div className={styles['caption-button-value']}>{value}</div>
        <TransitionChevron isActive={isActive} className={styles['caption-chevron']}/>
    </button>
};

export const SlidingWidgetFooter = ({onSwitch, onClose}) => {
    return <div className={styles['sliding-menu-footer']}>
        <button onClick={onSwitch} className={buttonStyles['primary']}>Switch</button>
        <button onClick={onClose} className={buttonStyles['secondary']}>Cancel</button>
    </div>
};

export default ({widgetKey, MenuActionButton, HeaderContents, MenuIcon, menuTitle, children, triggerChildren, TriggerButton, triggerClassName, triggerActiveClassName, MenuFooter, canClose, triggerDisabled, className}) => {
    const isActive = useSelector(state => state.menu.activeWidget === widgetKey);
    const dispatch = useDispatch();
    const buttonRef = useRef(null);

    const open = () => {
        dispatch({
            type: "MENU:OPEN-WIDGET",
            payload: widgetKey
        })
    };

    const close = () => {
        if(!canClose || canClose()) {
            dispatch({
                type: "MENU:CLOSE-WIDGET"
            })
        }
    };

    const toggleMenu = () => {
        if(isActive){
            close();
        } else {
            open();
        }
    };

    return <>
        {triggerChildren && <button disabled={triggerDisabled} ref={buttonRef} className={classNames(triggerClassName, {[triggerActiveClassName]: isActive})} onClick={toggleMenu}>
            {triggerChildren}
        </button>}
        {TriggerButton && <TriggerButton disabled={triggerDisabled} buttonRef={buttonRef} isActive={isActive} className={classNames(triggerClassName, {[triggerActiveClassName]: isActive})} onClick={toggleMenu}/>}
        <SlidingHeaderMenu className={className} contentClassName={styles['sliding-menu-content']} Footer={MenuFooter} maskClassName={styles['sliding-menu-mask']} containerClassName={styles['sliding-header-menu']} isActive={isActive} closeTrigger={(e) => {
            if(e.target !== buttonRef.current) {
                close();
            }
        }} title={menuTitle} Icon={MenuIcon} ActionButton={MenuActionButton} HeaderContents={HeaderContents}>
            {children}
        </SlidingHeaderMenu>
    </>
};
